import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

const GalleryHeader = React.lazy(() => import("pages/Gallery/sections/GalleryHeader"));
const GalleryGrid = React.lazy(() => import("pages/Gallery/sections/GalleryGrid"));

function GalleryPage() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Helmet>
                <title>Galerie Foto | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Vezi galeria foto cu rezultatele serviciilor noastre de curățenie profesională. Înainte și după imagini care arată calitatea serviciilor noastre."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/galerie/" />
            </Helmet>
            <GalleryHeader />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <GalleryGrid />
            </Card>
        </Suspense>
    );
}

export default GalleryPage;
